export const formatNumber = n => {
  if (n < 1e3) return n;
  if (n >= 1e3 && n < 1e5) return +(n / 1e3).toFixed(1) + 'K';
  if (n >= 1e5 && n < 1e6) return +(n / 1e5).toFixed(1) + 'L';
  if (n > 1e6 && n < 1e7) return +(n / 1e5).toFixed(2) + 'L';
  if (n >= 1e7 && n < 1e12) return +(n / 1e7).toFixed(1) + 'Cr';
  if (n >= 1e12) return +(n / 1e12).toFixed(1) + 'T';
};

export const numberWithCommas = num => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
